export enum Country {
  ID = 'indonesia',
  MY = 'malaysia',
  PH = 'philippines',
  SG = 'singapore',
  TH = 'thailand',
  VN = 'vietnam',
}
